import * as React from "react";
import {
  Edit,
  EditProps,
  useGetRecordRepresentation,
  useNotify,
  useRedirect,
  useRefresh,
  useResourceContext,
  useTranslate,
} from "react-admin";
import RecordTitle from "./RecordTitle";

interface CustomEditProps extends EditProps {
  children: React.ReactNode;
}

export default function CustomEdit({
  children,
  redirect: redirectTo = "show",
  ...props
}: CustomEditProps) {
  const resource = useResourceContext(props);
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const translate = useTranslate();
  const getRecordRepresentation = useGetRecordRepresentation(resource);

  function safeTranslate(
    key: string,
    options: Parameters<typeof translate>[1]
  ): string | null {
    const result = translate(key, options);
    return result === key ? null : result;
  }

  return (
    <Edit
      mutationMode="pessimistic"
      title={<RecordTitle />}
      {...props}
      mutationOptions={{
        ...props.mutationOptions,
        onSuccess: (record) => {
          const name = getRecordRepresentation(record);
          const translationKey = `resources.${resource}.notification.updated`;
          const fallbackKey = "notification.updated";
          const messageArgs = { name, smart_count: 1 };

          const hasResourceKey = translate(translationKey, messageArgs) !== translationKey;
          notify(hasResourceKey ? translationKey : fallbackKey, {
            type: "info",
            messageArgs,
          });
          redirect(redirectTo, resource, record?.id, record);
        },
      }}
    >
      {children}
    </Edit>
  );
}
